module.exports=(a,...b)=>{if("function"==typeof a)return a(...b)};